// [az]{2}-[AZ]{2}
export type LanguageCode = string;

export const is12Hour = (languageCode: LanguageCode) => {
  return Intl.DateTimeFormat(languageCode, {
    hour: 'numeric',
  }).resolvedOptions().hour12;
};

export const getDateTimeFormatString = (
  languageCode: LanguageCode,
  hideTime?: boolean,
) => {
  const formatObj = new Intl.DateTimeFormat(languageCode).formatToParts(
    new Date(),
  );

  let formatString = formatObj
    .map((obj) => {
      switch (obj.type) {
        case 'day':
          return 'dd';
        case 'month':
          return 'MM';
        case 'year':
          return 'yyyy';
        default:
          return obj.value;
      }
    })
    .join('');

  if (!hideTime)
    formatString = `${formatString} ${
      is12Hour(languageCode) ? 'hh:mm a' : 'HH:mm'
    }`;
  return formatString;
};
